import { cn } from "@/lib/utils";
import React from "react";

const MaxWidthWrapper = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        `max-w-screen-2xl mx-auto w-full md:px-10 px-2.5 ${className}`
      )}
    >
      {children}
    </div>
  );
};

export default MaxWidthWrapper;
